<template>
  <div id="searchBar">
    <input
      v-model="inputValue"
      id="searchInput"
      ref="searchInput"
      type="text"
      :placeholder="$t('map_detail.search_panel.place_holder')"
    />
  </div>
</template>
<script>
export default {
  name: 'MapSearchBar',
  data: () => ({
    inputValue: null,
  }),
  watch: {
    inputValue: function (newVal) {
      this.$emit('search', newVal);
    },
  },
};
</script>
<style scoped>
#searchBar {
  border-bottom: solid 1px #dddddd;
  flex: 0 1 auto;
  padding: 20px 20px 10px 20px;
  text-align: left;
}

#searchBar input {
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  font-size: 20px;
  width: 100%;
}
</style>
